import { AlertActions } from "@evertrue/et-components";

export default AlertActions;
